import React, {ChangeEvent} from "react";

interface HeaderProps {
    init: (samples: string[]) => Promise<void>;
    setSamples: (samples: string[]) => void;
    playing: boolean;
    busy: boolean;
    startStop: () => Promise<any>;
    randomize: () => void;
    reset: () => void;
    onExport: () => void;
    exporting: boolean;
    initialized: boolean;
    locksRef: React.RefObject<boolean[]>;
    setLocks: (locks: boolean[]) => void;
}

function Header(props: HeaderProps) {
    const [fileName, setFileName] = React.useState<string>('');
    const fileInputRef = React.useRef<HTMLInputElement>(null);

    const setLock = (index: number) => {
        props.locksRef.current[index] = !props.locksRef.current[index]
        props.setLocks([...props.locksRef.current])
    }

    const handleFiles = async (files: File[]) => {
        if (props.playing) {
            await props.startStop()
        }
        props.reset()
        const selected = files.slice(0, 5) // engine caps at 5 samples
        setFileName(selected.map(file => file.name).join(', '))
        const urls = selected.map(file => URL.createObjectURL(file))
        props.setSamples(urls)
        // hand the urls over directly — setSamples only lands on the next render
        await props.init(urls)
    }

    const buttonWidth = 130

    return <div className="row mt-3 mb-4">
        <div className="col">

            <div className="d-flex flex-row mt-2">

                <input
                    type="file"
                    ref={fileInputRef}
                    accept=".wav,audio/wav"
                    multiple
                    style={{display: 'none'}}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        if (e.target.files && e.target.files.length > 0) {
                            handleFiles(Array.from(e.target.files))
                        }
                    }}
                />
                <button
                    type="button"
                    className="btn btn-sm btn-outline-light w-100"
                    disabled={props.playing}
                    style={{opacity: props.playing ? 0.5 : 1}}
                    onClick={() => fileInputRef.current?.click()}
                >
                    <span className="py-2 d-block text-truncate">
                        {fileName || 'SELECT AUDIO FILE(S)'}
                    </span>
                </button>

            </div>
            <div className="d-flex flex-row mt-2">
                <button
                    style={{minWidth: buttonWidth}}
                    className={`btn btn-sm  me-3 ${props.playing ? "btn-outline-warning" : "btn-outline-success"}`}
                    disabled={props.busy}
                    onClick={() => {
                        props.startStop()
                    }}>{props.playing ? "STOP" : "PLAY"}
                </button>
                <button
                    disabled={props.exporting || props.busy || !props.initialized}
                    style={{minWidth: buttonWidth}}
                    className={`me-3 btn btn-sm btn-outline-light`}
                    onClick={props.onExport}>
                    {props.exporting ? "RENDERING..." : "EXPORT"}
                </button>

                <button
                    className={`me-3 btn btn-sm btn-outline-light ${props.locksRef.current[0] ? 'bg-light text-dark' : ''}`}
                    onClick={() => setLock(0)}>
                    
                </button>
                <button
                    className={`btn btn-sm btn-outline-light ${props.locksRef.current[1] ? 'bg-light text-dark' : ''}`}
                    onClick={() => setLock(1)}>
                    
                </button>
            </div>
            <div className="d-flex flex-row mt-2">
                <button
                    style={{minWidth: buttonWidth}}
                    className={`me-3 btn btn-sm btn-outline-light`}
                    onClick={props.randomize}>
                    M<span style={{color: '#04b99e'}}></span>NGL<span style={{color: '#01aef3'}}>3</span>
                </button>
                <button
                    style={{minWidth: buttonWidth}}
                    className={`me-3 btn btn-sm btn-outline-light`}
                    onClick={props.reset}>
                    RESET
                </button>

                <button
                    className={`me-3 btn btn-sm btn-outline-light ${props.locksRef.current[2] ? 'bg-light text-dark' : ''}`}
                    onClick={() => setLock(2)}>
                    
                </button>
                <button
                    className={`btn btn-sm btn-outline-light ${props.locksRef.current[3] ? 'bg-light text-dark' : ''}`}
                    onClick={() => setLock(3)}>
                    
                </button>
            </div>
        </div>
    </div>
}

export default Header
